export default __webpack_public_path__ + "static/media/ic_shuttle_ko.730e8d35.svg";